module.exports = __webpack_public_path__ + "img/cmhof-hero@2x.19546cec.jpg";